import { defineMessages } from 'react-intl';

export const notesSectionMessages = defineMessages({
  sectionTitle: {
    defaultMessage: 'Notes',
    id: 'OpOd2Z',
    description: 'Title of the notes card in the freight details view',
  },
});
